<template>
  <div class="send-datetime-configuration">
    <v-row>
      <v-col class="py-0">
        <p class="periodo-card-title">Frequência de envio</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-0">
        <tooltip fit-content align="right" :disabled="!isIndustryCampaign" :message="tooltipMessage">
          <v-radio-group v-model="frequencyTypeLocal" dense hide-details class="mt-0" :disabled="disabled">
            <div class="frequency-radios">
              <v-radio :label="$t('campanhas.somente_uma_vez')" value="ONETIME" @change="setFrequency" />
              <v-radio value="RECURRENT">
                <template v-slot:label>
                  <div class="d-flex align-center" @click="frequencyTypeLocal = 'RECURRENT'">
                    {{ $t('campanhas.repetir_cada') }}
                    <mf-number-input
                      v-model="frequencyIntervalLocal"
                      class="quantidade-dias pt-0 mt-0"
                      :outlined="false"
                      :disabled="frequencyTypeLocal !== 'RECURRENT'"
                      :style="{ width: frequencyIntervalLocal.toString().length + 'ch' }"
                      hide-details
                    />
                    {{ $t('campanhas.dias') }}
                  </div>
                </template>
              </v-radio>
            </div>
          </v-radio-group>
        </tooltip>

        <p v-if="error" class="error--text">{{ errorMessage }}</p>
        <div class="frequency-info">
          <span v-if="frequencyTypeLocal === 'RECURRENT'" class="d-flex align-center">
            <mf-icon class="mr-1" size="20">info</mf-icon>
            O envio de campanhas recorrentes ocorre apenas até o fim do período de mensuração.
          </span>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  components: {
    Tooltip: () => import('@/modules/campanhas/gestao-ofertas-v2/views/components/Tooltip.vue'),
  },
  props: {
    frequencyType: String,
    frequencyInterval: Number,
    error: Boolean,
    height: {
      type: String,
      default: '320px',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tooltipMessage: {
      type: String,
      default: '',
    },
    isIndustryCampaign: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    errorMessage() {
      if (this.error && this.frequencyType === 'RECURRENT') return 'A frequência precisa ser maior do que 0.'
      return ''
    },
    frequencyTypeLocal: {
      get() {
        return this.frequencyType
      },
      set(value) {
        this.$emit('update:frequencyType', value)
      },
    },
    frequencyIntervalLocal: {
      get() {
        return this.frequencyInterval || 1
      },
      set(value) {
        this.$emit('update:frequencyInterval', parseInt(value))
      },
    },
  },
  mounted() {
    if (this.frequencyType === 'ONETIME') {
      this.frequencyIntervalLocal = 1
    }
  },
  methods: {
    setFrequency() {
      this.$emit('update:frequencyInterval', 1)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep.send-datetime-configuration {
  .periodo-card-title {
    margin-bottom: 2px;
    font-size: 18px;
    font-weight: 400;
    color: $cinza-d10;
  }
  .frequency {
    &-radios {
      display: flex;
      column-gap: 32px;
      white-space: nowrap;
      align-items: center;
      .quantidade-dias {
        max-width: 50px;
        margin: 0 5px;
        .v-input__slot input {
          text-align: center;
          padding: 0;
        }
      }
    }
    &-info {
      margin-top: 12px;
      white-space: nowrap;
    }
  }
  .v-radio.theme--light {
    margin-bottom: 0;
  }
}
</style>
